import React from 'react';

const Divider: React.FC = () => {
  return <div className="my-2 border-t border-gray-300" role="separator" data-testid="divider" />;
};

export default Divider;
